export default "__VITE_ASSET__15cfd74b__"